import { InputField } from '@mews-commander/legacy-form';
import { IconButton, IconName, Stack, StackItem } from '@optimus-web/core';

const EMAIL_FIELD_PLACEHOLDER = 'example@email.com';

interface SendEmailDialogInputRowProps {
    name: string;
    onClose: () => void;
}

const SendEmailDialogInputRow = ({ name, onClose }: SendEmailDialogInputRowProps) => (
    <Stack spacing="200" fill itemAlignment="center">
        <StackItem grow>
            <InputField name={name} placeholder={EMAIL_FIELD_PLACEHOLDER} size="medium" autoComplete="off" />
        </StackItem>
        <IconButton icon={IconName.Delete} onClick={onClose} size="medium" variant="ghost" type="submit" />
    </Stack>
);

export default SendEmailDialogInputRow;
